import { currencyColumn, dateColumn, primaryRelationshipColumn, roleColumn } from "./columnHelpers";
import { objectDefinition } from "./supportedObjects";

const {pluralName, color, endpoint} = objectDefinition('donation');

export const donationEntriesRelationship = {
    collapsible: true,
    title: pluralName,
    tint: color,
    type: 'table',
    columns: [
        dateColumn({label: 'Donation Date', column: 'donation_date'}),
        currencyColumn(),
    ],
};
